export const filterPopUpCommonOptions = [
  { key: "all", value: "All" },
  { key: "1", value: "NonPay" },
  { key: "2", value: "Insured" },
  { key: "3", value: "Company" },
];
export const filterPopUpStatusOptions = [
  { key: "0", value: "All" },
  { key: "1", value: "Open" },
  { key: "2", value: "Completed" },
  { key: "3", value: "Overdue" },
];
